export const checkPostStatusVerifyUserKYC = async (data, token) => {
  const response = await fetch(`https://api.shuftipro.com/status/`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  return result;
};
